import React from 'react';
import { useDispatch } from 'react-redux';
import { clearAgent } from 'store/Agents/actions';
import {
  Wrapper, SecondContainer, CancelButton, Next
} from './styled';

const Header = ({
  back, cancel, next, finish, nextDisable
}) => {
  const dispatch = useDispatch();
  const onCancel = () => {
    dispatch(clearAgent());
    cancel();
  };
  return (
    <Wrapper>
      {back && <CancelButton id="modal-agents-back" onClick={ back }> Back </CancelButton>}
      <SecondContainer>
        {cancel && <CancelButton id="modal-agents-cancel" onClick={ onCancel }>Cancel</CancelButton>}
        {next && <Next id="modal-agents-next" onClick={ next } disabled={ nextDisable }>Next</Next>}
        {finish && <Next id="modal-agents-finish" onClick={ finish }>Finish</Next>}
      </SecondContainer>
    </Wrapper>
  );
};

export default Header;
